import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Brings the element `#id` into view once the page has rendered it, when the URL carries that hash (a link from Books). */
export function useScrollToHash(id: string, ready: boolean) {
  const { hash } = useLocation();
  useEffect(() => {
    const el = ready && hash === `#${id}` ? document.getElementById(id) : null;
    if (!el) return;
    // Sections above can still change height as their own data lands, which would leave the target scrolled past:
    // keep it at the top until the layout settles.
    let top: number | null = null;
    const pin = () => {
      if (el.offsetTop === top) return;
      top = el.offsetTop;
      el.scrollIntoView({ block: "start" });
    };
    pin();
    const timer = window.setInterval(pin, 100);
    const stop = window.setTimeout(() => window.clearInterval(timer), 1500);
    return () => {
      window.clearInterval(timer);
      window.clearTimeout(stop);
    };
  }, [id, ready, hash]);
}
